import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { mediumDarkGrey, white, defaultBoxShadow } from '../../../styles/colors';

import { launchpadSelectors } from '../reducer/launchpad-reducer';
import { lionSelectors } from '@rosetta/react-lion/dist/index';
import warningCalendar from '../../../assets/images/warning_calendar.png';

const WarningBox = styled.div(() => {
  let style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    padding: '25px',
    backgroundColor: white,
    marginBottom: '10px',
    boxShadow: defaultBoxShadow,
    borderRadius: '4px'
  };
  return style;
});

const WarningHeading = styled.div(() => {
  let style = {
    width: 'auto',
    marginRight: '25px',
    fontSize: '16px',
    lineHeight: '18px'
  };
  return style;
});

const WarningCalendar = styled.div(() => {
  let style = {
    backgroundImage: 'url(' + warningCalendar + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    width: '74px',
    height: '80px',
    flexShrink: '0'
  };
  return style;
});

const WarningCounter = styled.div(() => {
  let style = {
    width: '100%',
    height: '100%',
    paddingTop: '27px',
    paddingRight: '2px',
    fontSize: '40px',
    color: mediumDarkGrey,
    textAlign: 'center'
  };
  return style;
});

//*********************************************
export class TestWarning extends PureComponent {
  componentWillMount = () => {};

  /*
    render!
   */
  render = () => {
    let warningHeaderText = '<b>' + this.props.lionTranslateString('proficiency_warning_headline') + '</b>';
    let daysUntilTriggerKey = 'proficiency_warning_message';
    if (this.props.daysUntilTrigger === 1) {
      daysUntilTriggerKey = 'proficiency_warning_message_singular';
    }
    let daysUntilTriggerText = this.props.lionTranslateString(daysUntilTriggerKey);
    daysUntilTriggerText = daysUntilTriggerText.replace('{X}', this.props.daysUntilTrigger);
    warningHeaderText += '&nbsp&nbsp' + daysUntilTriggerText;

    return (
      <WarningBox>
        <WarningHeading dangerouslySetInnerHTML={{ __html: warningHeaderText }} />
        <WarningCalendar>
          <WarningCounter>{this.props.daysUntilTrigger}</WarningCounter>
        </WarningCalendar>
      </WarningBox>
    );
  };
}

TestWarning.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  daysUntilTrigger: launchpadSelectors.daysUntilTrigger(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = {};
export const TestWarningContainer = connect(
  mapStateToProps,
  wrapActions
)(TestWarning);



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/TestWarning.jsx